angular.module('dpw.components')

    .component('dpwEditProfileBasicInfo', {
        templateUrl: 'dpw-edit-profile-basic-info.html',
        controller: ['$rootScope', '$scope', '$timeout', '$interval', '$window', 'popupUtil', 'editProfileUtils', 'wizard', 'GoogleRecaptcha', 'SimpleForm',
            function ($rootScope, $scope, $timeout, $interval, $window, popupUtil, editProfileUtils, wizard, GoogleRecaptcha, SimpleForm) {
                var $ctrl = this;

                $ctrl.$onInit = function () {
                    $ctrl.formConfig = $ctrl.editProfileCtrl.formsConfig.basicInfo;

                    // TODO: Can be improved - Use a class to organize the fields.
                    $ctrl.fieldsConfig = {
                        email: {
                            fieldName: 'email',
                            keyName: 'email',
                            onChange: function () {
                                var fieldConfig = this;
                                $ctrl.editProfileCtrl.onFieldChange($ctrl.formConfig, fieldConfig, $ctrl);
                            },
                            validation: {
                                errorKey: 'validEmailAddress',
                                validator: $.validator.methods.customEmailWithBackList,
                                errorCode: 'FRONT_END_VALIDATION_INVALID_EMAIL_ADDRESS'
                            },
                            errorHandler: [{
                                code: 'INVALID_EMAIL_ADDRESS',
                                action: $ctrl.editProfileCtrl.buildHandlerAction($ctrl.formConfig)
                            }, {
                                code: 'EMAIL_ADDRESS_UNIQUENESS',
                                action: $ctrl.editProfileCtrl.buildHandlerAction($ctrl.formConfig)
                            }],
                            fieldErrors: [],
                            errorMessages: {
                                'FRONT_END_VALIDATION_INVALID_EMAIL_ADDRESS': RCDPW.Lang.EditProfile.INVALID_EMAIL_ADDRESS,
                                'INVALID_EMAIL_ADDRESS': RCDPW.Lang.EditProfile.INVALID_EMAIL_ADDRESS,
                                'EMAIL_ADDRESS_UNIQUENESS': RCDPW.Lang.EditProfile.EMAIL_ADDRESS_UNIQUENESS
                            },
                            change: openChangeEmail
                        },
                        firstName: {
                            fieldName: 'firstName',
                            keyName: 'firstName',
                            onChange: function () {
                                var fieldConfig = this;
                                $ctrl.editProfileCtrl.onFieldChange($ctrl.formConfig, fieldConfig, $ctrl);
                            },
                            validation: {
                                errorKey: 'validFirstName',
                                validator: $.validator.methods.freeSignUpStaticText,
                                errorCode: 'FRONT_END_VALIDATION_INVALID_FIRST_NAME'
                            },
                            fieldErrors: [],
                            errorMessages: {
                                'FRONT_END_VALIDATION_INVALID_FIRST_NAME': RCDPW.Lang.EditProfile.INVALID_FIRST_NAME
                            }
                        },
                        lastName: {
                            fieldName: 'lastName',
                            keyName: 'lastName',
                            onChange: function () {
                                var fieldConfig = this;
                                $ctrl.editProfileCtrl.onFieldChange($ctrl.formConfig, fieldConfig, $ctrl);
                            },
                            validation: {
                                errorKey: 'validLastName',
                                validator: $.validator.methods.freeSignUpStaticText,
                                errorCode: 'FRONT_END_VALIDATION_INVALID_LAST_NAME'
                            },
                            fieldErrors: [],
                            errorMessages: {
                                'FRONT_END_VALIDATION_INVALID_LAST_NAME': RCDPW.Lang.EditProfile.INVALID_LAST_NAME
                            }
                        },
                        contactPhone: {
                            fieldName: 'contactPhone',
                            keyName: 'contactPhone',
                            onChange: function () {
                                var fieldConfig = this;
                                $ctrl.editProfileCtrl.onFieldChange($ctrl.formConfig, fieldConfig, $ctrl);
                            },
                            validation: {
                                errorKey: 'validContactPhone',
                                validator: function (value) {
                                    var isValid = $.validator.methods.freeSignUpPhoneNumber(value);
                                    return isValid && value.replace(/[^\d]/g, '').length >= 6;
                                },
                                errorCode: 'FRONT_END_VALIDATION_INVALID_CONTACT_PHONE'
                            },
                            errorHandler: [{
                                code: 'INVALID_BUSINESS_PHONE',
                                action: $ctrl.editProfileCtrl.buildHandlerAction($ctrl.formConfig)
                            }, {
                                code: 'INVALID_BUSINESS_PHONE_FORWARDED_NUMBER',
                                action: $ctrl.editProfileCtrl.buildHandlerAction($ctrl.formConfig)
                            }, {
                                code: 'INVALID_BUSINESS_PHONE_TOLL_FREE_NUMBER',
                                action: $ctrl.editProfileCtrl.buildHandlerAction($ctrl.formConfig)
                            }],
                            fieldErrors: [],
                            errorMessages: {
                                'FRONT_END_VALIDATION_INVALID_CONTACT_PHONE': RCDPW.Lang.EditProfile.INVALID_PHONE_NUMBER,
                                'INVALID_BUSINESS_PHONE': RCDPW.Lang.EditProfile.INVALID_PHONE_NUMBER,
                                'INVALID_BUSINESS_PHONE_FORWARDED_NUMBER': RCDPW.Lang.EditProfile.INVALID_PHONE_NUMBER_FORWARDED_NUMBER,
                                'INVALID_BUSINESS_PHONE_TOLL_FREE_NUMBER': RCDPW.Lang.EditProfile.INVALID_PHONE_NUMBER_TOLL_FREE_NUMBER
                            }
                        }
                    };
                };

                $ctrl.$onChanges = function (changesObj) {
                    var isUserAccessible = _.get(changesObj, 'isUserAccessible.currentValue', false);
                    if (isUserAccessible) {
                        fetchProfile();
                        $ctrl.$onChanges = null;
                    }
                };

                $ctrl.onFieldFocus = function (fieldName) {
                    $ctrl.formConfig.setFieldStatus(fieldName, '$setUntouched');
                };

                $ctrl.submit = function () {
                    $ctrl.formConfig.setFieldsStatus('$setTouched');
                    if (!$ctrl.formConfig.getFormStatus('$valid')) {
                        return;
                    }

                    var profile = editProfileUtils.profileAdapter($ctrl.profile, {
                        neededFields: ['email', 'firstName', 'lastName', 'contactPhone'],
                        keyNameAlias: {
                            'contactPhone': 'businessPhone'
                        }
                    });

                    editProfileUtils.updateProfile(profile, function () {
                        fetchProfile();

                        $scope.$broadcast('dpwSaveStatus:showSavedStatus');
                        $rootScope.$broadcast('dpwHeader:updateUserInfo');

                        $ctrl.formConfig.setFormStatus('$setUntouched');
                    }, errorHandler);
                };

                $ctrl.updateEmail = function () {
                    editProfileUtils.fetchProfile(function (data) {
                        var newEmail = _.get(data, 'developer.email');
                        $ctrl.editProfileCtrl.dirtyCheck.updateData($ctrl, {
                            email: newEmail
                        });
                    });
                };

                function errorHandler(data, defaultErrorHandler) {
                    var handlerConfig = {
                        // Definitions for "Basic Info" form go here.
                    };

                    _.assign(handlerConfig, editProfileUtils.extractHandlerConfig($ctrl.fieldsConfig));

                    $ctrl.editProfileCtrl.errorDispatcher(data, handlerConfig, defaultErrorHandler);
                }

                function fetchProfile() {
                    editProfileUtils.fetchProfile(function (data) {
                        $ctrl.profile = editProfileUtils.profileAdapter(data.developer, {
                            neededFields: ['email', 'firstName', 'lastName', 'contactPhone']
                        });

                        $ctrl.originalProfile = _.cloneDeep($ctrl.profile);

                        $ctrl.editProfileCtrl.dirtyCheck.perform($ctrl.formConfig, $ctrl);
                    });
                }

                function openChangeEmail() {
                    var config = {
                        name: 'changeProfileEmail',
                        title: 'Change email',
                        extraClass: 'dpw-change-profile-email',
                        onInit: onInit,
                        postLink: postLink
                    };

                    wizard.create(config);

                    function onInit(wizardCtrl) {
                        wizardCtrl.formsConfig = {
                            newEmail: new SimpleForm({
                                formName: 'newEmail',
                                className: 'change-profile-email-newEmail'
                            }),
                            code: new SimpleForm({
                                formName: 'code',
                                className: 'change-profile-email-code'
                            })
                        };

                        wizardCtrl.fieldsConfig = {
                            originalEmail: {
                                value: $ctrl.profile.email
                            },
                            newEmail: {
                                name: 'newEmail',
                                onChange: function () {
                                    var fieldConfig = this;
                                    wizardCtrl.onFieldChange(wizardCtrl.formsConfig.newEmail, fieldConfig);
                                },
                                onFocus: function () {
                                    var fieldConfig = this;
                                    wizardCtrl.onFieldFocus(wizardCtrl.formsConfig.newEmail, fieldConfig);
                                },
                                validation: [{
                                    errorKey: 'validEmailAddress',
                                    validator: $.validator.methods.customEmailWithBackList,
                                    errorCode: 'FRONT_END_VALIDATION_INVALID_EMAIL_ADDRESS'
                                }, {
                                    errorKey: 'emailIsChanging',
                                    validator: function (value) {
                                        return value !== wizardCtrl.fieldsConfig.originalEmail.value;
                                    },
                                    errorCode: 'FRONT_END_VALIDATION_EMAIL_IS_NOT_CHANGING'
                                }],
                                errors: [],
                                messages: {
                                    'FRONT_END_VALIDATION_INVALID_EMAIL_ADDRESS': RCDPW.Lang.EditProfile.INVALID_EMAIL_ADDRESS,
                                    'FRONT_END_VALIDATION_EMAIL_IS_NOT_CHANGING': RCDPW.Lang.EditProfile.EMAIL_IS_NOT_CHANGING,
                                    'INVALID_EMAIL_ADDRESS': RCDPW.Lang.EditProfile.INVALID_EMAIL_ADDRESS,
                                    'EMAIL_ADDRESS_UNIQUENESS': RCDPW.Lang.EditProfile.EMAIL_ADDRESS_UNIQUENESS
                                }
                            },
                            password: {
                                name: 'password',
                                onChange: function () {
                                    var fieldConfig = this;
                                    wizardCtrl.onFieldChange(wizardCtrl.formsConfig.newEmail, fieldConfig);
                                },
                                onFocus: function () {
                                    var fieldConfig = this;
                                    wizardCtrl.onFieldFocus(wizardCtrl.formsConfig.newEmail, fieldConfig);
                                },
                                errors: [],
                                messages: {
                                    'INVALID_OLD_PASSWORD': RCDPW.Lang.MyAccount.ACCOUNT_INCORRECT_PASSWORD
                                }
                            },
                            code: {
                                name: 'code',
                                onChange: function () {
                                    var fieldConfig = this;
                                    wizardCtrl.onFieldChange(wizardCtrl.formsConfig.code, fieldConfig);
                                },
                                onFocus: function () {
                                    var fieldConfig = this;
                                    wizardCtrl.onFieldFocus(wizardCtrl.formsConfig.code, fieldConfig);
                                },
                                errors: [],
                                messages: {
                                    'VERIFICATION_CODE_ERROR': RCDPW.Lang.EditProfile.VERIFICATION_CODE_ERROR,
                                    'VERIFICATION_CODE_EXPIRED': RCDPW.Lang.EditProfile.VERIFICATION_CODE_EXPIRED
                                },
                                resend: function () {
                                    editProfileUtils.resendCode(onSuccess, onError);

                                    function onSuccess() {
                                        wizardCtrl.codeResendTimer.start();
                                    }

                                    function onError(data, defaultErrorHandler) {
                                        var errorHandlers = _.assign({}, wizardCtrl.errorHandlers, {});

                                        var errorCode = _.get(data, 'status.message');
                                        _.result(errorHandlers, errorCode, defaultErrorHandler);
                                    }
                                }
                            }
                        };

                        wizardCtrl.stepsConfig = [{
                            stepName: 'newEmail',
                            nextStepName: 'code',
                            onStepForward: function (stepForward, wizardCtrl) {
                                var formConfig = wizardCtrl.formsConfig.newEmail;
                                formConfig.setFieldsStatus('$setTouched');
                                if (!formConfig.getFormStatus('$valid') || _.isEmpty(wizardCtrl.googleRecaptcha.getResponse())) {
                                    return;
                                }

                                var data = {
                                    email: wizardCtrl.fieldsConfig.newEmail.value,
                                    password: wizardCtrl.fieldsConfig.password.value,
                                    googleRecaptcha: wizardCtrl.googleRecaptcha.getResponse()
                                };

                                editProfileUtils.confirmNewEmail(data, onSuccess, onError);

                                function onSuccess() {
                                    stepForward();
                                    wizardCtrl.codeResendTimer.start();
                                }

                                function onError(data, defaultErrorHandler) {
                                    wizardCtrl.googleRecaptcha.reset();

                                    var errorHandlers = _.assign({}, wizardCtrl.errorHandlers, {
                                        'INVALID_EMAIL_ADDRESS': function () {
                                            wizardCtrl.markFieldInvalid(formConfig, wizardCtrl.fieldsConfig.newEmail, 'INVALID_EMAIL_ADDRESS');
                                        },
                                        'EXT-305': function () {    // invalid old password
                                            wizardCtrl.markFieldInvalid(formConfig, wizardCtrl.fieldsConfig.password, 'INVALID_OLD_PASSWORD');
                                        }
                                    });

                                    var errorCode = _.get(data, 'status.message') || _.get(data, 'platformErrors.errorCode');
                                    _.result(errorHandlers, errorCode, defaultErrorHandler);
                                }
                            },
                            templateUrl: 'dpw-change-profile-email-newEmail.html'
                        }, {
                            stepName: 'code',
                            previousStepName: 'newEmail',
                            onStepBackward: function (stepBackward, wizardCtrl) {
                                stepBackward();

                                $timeout(function () {
                                    wizardCtrl.googleRecaptcha.render();
                                    wizardCtrl.fieldsConfig.code.value = '';
                                });
                            },
                            templateUrl: 'dpw-change-profile-email-code.html'
                        }];

                        wizardCtrl.errorHandlers = {
                            'EMAIL_ADDRESS_UNIQUENESS': function () {
                                if (wizardCtrl.stepManager.isStep('newEmail')) {
                                    wizardCtrl.markFieldInvalid(
                                        wizardCtrl.formsConfig.newEmail,
                                        wizardCtrl.fieldsConfig.newEmail,
                                        'EMAIL_ADDRESS_UNIQUENESS'
                                    );
                                } else {
                                    popupUtil.ok({
                                        content: wizardCtrl.fieldsConfig.newEmail.messages.EMAIL_ADDRESS_UNIQUENESS,
                                        btnName: 'Back',
                                        callback: function () {
                                            wizardCtrl.stepManager.stepBackward();
                                        }
                                    });
                                }
                            },
                            'GOOGLE_RECAPTCHA_ERROR': function () {
                                popupUtil.ok({
                                    content: RCDPW.Lang.EditProfile.GOOGLE_RECAPTCHA_ERROR
                                });
                            },
                            'VERIFICATION_CODE_RETRY_LIMIT': function () {
                                popupUtil.ok({
                                    content: RCDPW.Lang.EditProfile.VERIFICATION_CODE_RETRY_LIMIT
                                });
                            },
                            'VERIFICATION_INFO_NULL': function () {
                                popupUtil.ok({
                                    content: RCDPW.Lang.EditProfile.SERVICE_UNAVAILABLE,
                                    callback: function () {
                                        $window.location.reload();
                                    }
                                });
                            },
                            'VERIFICATION_CODE_RESEND_INTERVAL_LIMIT': function () {
                                popupUtil.ok({
                                    content: RCDPW.Lang.EditProfile.SERVICE_UNAVAILABLE
                                });
                            },
                            'TOO_MANY_REQUESTS': function () {
                                popupUtil.ok({
                                    content: RCDPW.Lang.EditProfile.SERVICE_UNAVAILABLE
                                });
                            },
                            'EXT-306': function () {    // too many failed verification requests
                                popupUtil.ok({
                                    content: RCDPW.Lang.MyAccount.PASSWORD_MULTIPLE_FAILURES
                                });
                            }
                        };

                        wizardCtrl.codeResendTimer = {
                            interval: 60,
                            count: 0,
                            start: function () {
                                var self = this;
                                self.count = self.interval;
                                $interval.cancel(self.timer);
                                self.timer = $interval(function () {
                                    self.count--;
                                    if (self.isAbleToResend()) {
                                        $interval.cancel(self.timer);
                                    }
                                }, 1000);
                            },
                            isAbleToResend: function () {
                                return this.count === 0;
                            }
                        };

                        wizardCtrl.submit = function () {
                            var formConfig = wizardCtrl.formsConfig.code;
                            if (!formConfig.getFormStatus('$valid')) {
                                formConfig.setFieldsStatus('$setTouched');
                                return;
                            }

                            var data = {
                                verificationCode: wizardCtrl.fieldsConfig.code.value
                            };

                            editProfileUtils.updateEmail(data, onSuccess, onError);

                            function onSuccess() {
                                wizardCtrl.close();
                                $ctrl.updateEmail();
                            }

                            function onError(data, defaultErrorHandler) {
                                var errorHandlers = _.assign({}, wizardCtrl.errorHandlers, {
                                    'VERIFICATION_CODE_NULL': function () {
                                        wizardCtrl.markFieldInvalid(formConfig, wizardCtrl.fieldsConfig.code, 'VERIFICATION_CODE_NULL');
                                    },
                                    'VERIFICATION_CODE_ERROR': function () {
                                        wizardCtrl.markFieldInvalid(formConfig, wizardCtrl.fieldsConfig.code, 'VERIFICATION_CODE_ERROR');
                                    },
                                    'VERIFICATION_CODE_EXPIRED': function () {
                                        wizardCtrl.markFieldInvalid(formConfig, wizardCtrl.fieldsConfig.code, 'VERIFICATION_CODE_EXPIRED');
                                    }
                                });

                                var errorCode = _.get(data, 'status.message') || _.get(data, 'platformErrors.errorCode');
                                _.result(errorHandlers, errorCode, defaultErrorHandler);
                            }
                        };

                        wizardCtrl.onFieldChange = function (formConfig, fieldConfig) {
                            var fieldCtrl = _.get(formConfig.getFormCtrl(), fieldConfig.name);
                            var fieldErrors = fieldConfig.errors;
                            var fieldValue = fieldConfig.value;

                            var validation = fieldConfig.validation;
                            if (validation) {
                                _.isPlainObject(validation) && validate(validation);
                                _.isArray(validation) && _.forEach(validation, validate);
                            }

                            function validate(config) {
                                // The situation when the value is empty is handled by other form validation mechanism.
                                var isValid = _.isEmpty(fieldValue) ? true : config.validator(fieldValue);

                                if (fieldCtrl) {
                                    formConfig.setFieldStatus(fieldConfig.name, '$setValidity', [config.errorKey, isValid]);

                                    if (isValid) {
                                        _.remove(fieldErrors, function (errorCode) {
                                            return errorCode === config.errorCode;
                                        });
                                    } else {
                                        !_.include(fieldErrors, config.errorCode) && fieldErrors.push(config.errorCode);
                                    }
                                }
                            }
                        };

                        wizardCtrl.onFieldFocus = function (formConfig, fieldConfig) {
                            formConfig.setFieldStatus(fieldConfig.name, '$setUntouched');
                        };

                        wizardCtrl.markFieldInvalid = function (formConfig, fieldConfig, errorCode) {
                            var fieldCtrl = _.get(formConfig.getFormCtrl(), fieldConfig.name);
                            var fieldErrors = fieldConfig.errors;

                            if (fieldCtrl) {
                                flagTheField();
                                clearTheFlagOnFieldChange();
                            }

                            function flagTheField() {
                                formConfig.setFieldStatus(fieldConfig.name, '$setValidity', [errorCode, false]);
                                !_.includes(fieldErrors, errorCode) && fieldErrors.push(errorCode);
                            }

                            function clearTheFlagOnFieldChange() {
                                var onChangeFn = fieldConfig.onChange;

                                fieldConfig.onChange = function () {
                                    formConfig.setFieldStatus(fieldConfig.name, '$setValidity', [errorCode, true]);
                                    _.remove(fieldErrors, function (code) {
                                        return code === errorCode;
                                    });

                                    fieldConfig.onChange = onChangeFn;

                                    fieldConfig.onChange();
                                };
                            }
                        };
                    }

                    function postLink(wizardCtrl) {
                        $timeout(function () {
                            wizardCtrl.googleRecaptcha = new GoogleRecaptcha('google-recaptcha');
                        });
                    }
                }
            }],
        bindings: {
            isUserAccessible: '<'
        },
        require: {
            editProfileCtrl: '^^dpwEditProfile'
        }
    })

;